export const environment = {
  authConfig: {
    production: true,
    clientId: 'ec8e0074-72ac-48f1-9ce2-47a0f2e394b9',
    authority: 'https://login.microsoftonline.com/41ff26dc-250f-4b13-8981-739be8610c21',
    validateAuthority: false,
    redirectUri: window.location.origin + '/internal',
    navigateToLoginRequestUrl: true,
    popUp: false,
  },
  production: true,
};
